import { useCallback, useState } from "react";

interface UseToggleProps {
    initialState?: boolean;
}

const useToggle = ({ initialState }: UseToggleProps) => {
    const [isToggled, setIsToggled] = useState(initialState);

    const open = useCallback(() => {
        setIsToggled(true);
    }, []);

    const close = useCallback(() => {
        setIsToggled(false);
    }, []);

    const toggle = useCallback(() => {
        setIsToggled((prev) => !prev);
    }, []);

    return {
        isToggled,
        open,
        close,
        toggle,
        setIsToggled,
    };
};

export default useToggle;
